import {
  dashboardDisabledMapTips,
  dashboardMapTips, 
} from '@/pages/opinion/components/BubbleCommon';
import { getDashboardGamePermissions } from '@/pages/opinion/services/dashboard';
import { gameInfoType } from '@/pages/opinion/types/common';
import { useEffect, useMemo, useState } from 'react';
const hostname = window.location.hostname;
export function useDashboardGamePermissions({
  gameInfo,
}: {
  gameInfo: gameInfoType;
}) {
  const [showDashboardBtn, setShowDashboardBtn] = useState(false);
  const [dashboardBtnDisabled, setDashboardBtnDisabled] = useState(true);
  const [dashboardGameCode, setDashboardGameCode] = useState<string | null>(
    null,
  );
  const dashboardUrl = useMemo(() => {
    return `/dashboard/game/${dashboardGameCode}/overview/daily`;
  }, [dashboardGameCode]);

  useEffect(() => {
    if (gameInfo.edition_unified_id) {
      getDashboardGamePermissions({
        unified_ids: [gameInfo.edition_unified_id],
      }).then((data: any) => {
        const { game_code, has_permissions } = data?.list[0] || {};
        setDashboardBtnDisabled(!has_permissions);
        setDashboardGameCode(game_code);
        setShowDashboardBtn(!!game_code);
      });
    }
  }, [gameInfo]);
  const dashboardTipsMap = useMemo(() => {
    const isGlobal = ['databrain-global.intlgame.com'].includes(hostname); 
    return dashboardBtnDisabled ? dashboardDisabledMapTips(isGlobal) : dashboardMapTips;
  }, [dashboardBtnDisabled]);

  return {
    dashboardUrl,
    showDashboardBtn,
    dashboardBtnDisabled,
    dashboardTipsMap,
  };
}
